




















































import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Partner } from '@/modules/kartoteka/partner';
import { listFactory } from '@/main/pages';
import { dropdownListProvider } from '@/main/dropdownApi';

import { NAME } from './constants';
import { store } from './store/list';
import { types } from './store/types';

type VozidloFilter = {
	VyrobekvozOzn: string | null;
	Spz: string | null;
};

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		VozidloSelect: Vozidlo.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakaznik: `${this.storeUri}/${types.mutations.DOKLAD_ZAKAZNIK_SELECT_MAPPER}`,
				vozidlo: `${this.storeUri}/${types.mutations.DOKLAD_VOZIDLO_SELECT_MAPPER}`,
			};
		},
		vozidloFilter(): VozidloFilter {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				Spz: this.Spz,
			};
		},
	},
	methods: {
		onProvozovnaChange() {
			if (this.ProvozovnaId) {
				dropdownListProvider.GetDokladDruhSM(this.ProvozovnaId).then(({ data }) => {
					this.dropdownList.DokladDruh = data;
				});
			}
		},
	},
});
